// extracted by mini-css-extract-plugin
export var author = "ResourcesSection-module--author--5c1e7";
export var backgroundImage = "ResourcesSection-module--backgroundImage--241cc";
export var date = "ResourcesSection-module--date--67f2c";
export var excerpt = "ResourcesSection-module--excerpt--5a196";
export var heading = "ResourcesSection-module--heading--9731e";
export var postCta = "ResourcesSection-module--postCta--13053";
export var postCtaWrapper = "ResourcesSection-module--postCtaWrapper--a9811";
export var postItemCode = "ResourcesSection-module--postItemCode--20548";
export var postItemContent = "ResourcesSection-module--postItemContent--79771";
export var postItemEducation = "ResourcesSection-module--postItemEducation--3b7a7";
export var postItemWrapper = "ResourcesSection-module--postItemWrapper--6b1da";
export var postList = "ResourcesSection-module--postList--37c54";
export var postTitle = "ResourcesSection-module--postTitle--bb671";
export var tag = "ResourcesSection-module--tag--99c47";
export var tagList = "ResourcesSection-module--tagList--ee5bc";
export var title = "ResourcesSection-module--title--01938";
export var titleWrapper = "ResourcesSection-module--titleWrapper--8d517";
export var wrapper = "ResourcesSection-module--wrapper--6bfdc";